

export const MILESTONES_FETCH_PROGRESS = "MILESTONES_FETCH_PROGRESS"
export const MILESTONES_RESET_PROGRESS = "MILESTONES_RESET_PROGRESS"
export const MILESTONES_SET_INSTANCE_NAME = "MILESTONES_SET_INSTANCE_NAME"
export const MILESTONES_SET_INTERACIONES = "MILESTONES_SET_INTERACIONES"
